import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ShopPageComponent } from './shop-page/shop-page.component';
import { AboutPageComponent } from './about-page/about-page.component';
import { CartPageComponent } from './cart-page/cart-page.component';
import { ItemModalComponent } from './shop-page/item-modal/item-modal.component';
import { ConfirmationPageComponent } from './cart-page/confirmation-page/confirmation-page.component';


const routes: Routes = [
  {path: 'about', component: AboutPageComponent},
  {path: 'cart', component: CartPageComponent},
  {path: 'confirmation', component: ConfirmationPageComponent},

  {path: 'original', component: ItemModalComponent, outlet: 'view_art'},
  {path: 'print', component: ItemModalComponent, outlet: 'view_art'},
  {path: 'past', component: ItemModalComponent, outlet: 'view_art'},
  {path: 'original/:id', component: ItemModalComponent, outlet: 'view_art'},
  {path: 'print/:id', component: ItemModalComponent, outlet: 'view_art'},
  {path: 'past/:id', component: ItemModalComponent, outlet: 'view_art'},
  {path: '', component: ShopPageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
